export default __webpack_public_path__ + "static/media/wichita2.3b43a595.jpeg";